// @flow
import React, { Fragment, useContext } from 'react';
import classnames from 'classnames';

import { t } from 'Src/i18n';
import Responsive from 'Components/utils/responsive/responsiveContext';

import { LineTitle } from 'Components/widgets/line-title/LineTitle';
import { Slider } from 'Components/frameworks/slider/Slider';

import { OfferPush } from 'Components/widgets/offers-push/OfferPush';
import DynamicLink from 'Components/frameworks/dynamic-link/DynamicLink';
import { TrackClick } from 'Tracking/track-click/TrackClick';

type Props = CMSOffersPush;

export const OffersPushLineLarge = ({ title, seeMoreLabel, seeMoreLink, columns }: Props) => {
  // use isDesktop to display slider's controls only on desktops
  const { isDesktop } = useContext(Responsive);

  return (
    <Fragment>
      <div className="flex flex-wrap justify-between">
        {title && <LineTitle className="flex-1 md:flex-none">{title}</LineTitle>}
        {seeMoreLabel &&
          seeMoreLink && (
            <TrackClick
              as={DynamicLink}
              className="m-auto md:mx-0 mt-4 md:mt-1 order-last md:order-none text-base text-gray-darker hover:text-gray-active focus:text-gray-active underline"
              trackingData={{
                actionGA: 'main_push_offers',
                labelGA: 'seeMore',
              }}
              url={seeMoreLink}
            >
              {seeMoreLabel}
            </TrackClick>
          )}
      </div>
      <div className="-mx-5 lg:mx-0 w-screen lg:w-full">
        <Slider
          cols={0}
          hasControls={isDesktop}
          nbItemsToScroll={2}
          scrollAreaContainerClassName="overflow-x-auto lg:overflow-hidden"
          scrollBackwardLabel={t('common.scrollBackward')}
          scrollForwardLabel={t('common.scrollForward')}
          navPosition="center"
          scrollControlsClassName="-mx-5 lg:mx-0"
        >
          {columns.map((column, index) => (
            <div
              className={classnames('flex-1 sm:w-1/3 rtl:ml-5', {
                'lg:rtl:ml-0': index === 0,
              })}
              style={{ width: '85vw', maxWidth: '380px' }}
              key={index}
            >
              <OfferPush {...column} id={index + 1} />
            </div>
          ))}
          <div
            style={{ width: '20px', height: '1px', flexShrink: '0' }}
            className="lg:hidden rtl:-order-1"
          />
        </Slider>
      </div>
    </Fragment>
  );
};
